import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  guards: {
    registered: { action: 'block' }
  }
} satisfies RecursivePartial<DialogConfig['signIn']>
